import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    iconInvestedProjectsTitle: {
        fontSize: '36.82px !important',
    },
    contentInvestedProjects: {
        borderRadius: '20px',
        border: '2px solid #00DD9E',

    },
    imageInvestedProjects: {
        width: '100%',
        height: '450px',
        margin: 0,
        padding: 0,
        display: 'block',

        [theme.breakpoints.up('sm')]: {
            borderRadius: '20px 0 0 20px',
            height: '100%',

        },
        [theme.breakpoints.down('xs')]: {
            borderRadius: '20px 20px 0 0',
        },
        '@media (max-width: 768px) and (max-height: 1024px)': {
            borderRadius: '20px 20px 0 0',
        },

    },
    contentInvestedProjectsTitle: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '0px 14px 0px 14px'

    },
    titleInvestedProjects: {
        fontFamily: 'MontserratBold',
        fontSize: '40px',
        fontWeight: '700',
        lineHeight: '50px',
        letterSpacing: '0em',
        textAlign: 'left',
        color: '#FFFFFF',
        marginBottom: 10
    },
    countryInvestedProjects: {
        fontFamily: 'MontserratSemiBold',
        fontSize: '30px',
        fontWeight: 500,
        lineHeight: '38px',
        letterSpacing: '0em',
        textAlign: 'left',
        color: '#FFFFFF',
        marginBottom: 30

    },
    nftsInvestedProjects: {
        fontFamily: 'MontserratSemiBold',
        fontSize: '30px',
        fontWeight: 500,
        lineHeight: '38px',
        letterSpacing: '0em',
        textAlign: 'left',
        color: '#FFFFFF',
        marginBottom: 40

    },
    descriptionInvestedProjects: {
        fontFamily: 'Montserrat',
        fontSize: '25px',
        fontWeight: 400,
        lineHeight: '32px',
        letterSpacing: '0em',
        textAlign: 'left',
        color: '#FFFFFF',
        marginBottom: 20

    },
    containerCountryInvestedProjects: {
        display: 'flex',
    },
    pinLocationInvestedProjects: {
        width: '33px',
        height: '33px',
        // marginLeft: 2

    },
    contentButtonViewPerformance: {
        display: 'flex',
        justifyContent: 'flex-start',
        // background: 'red'
    }
}));

export default useStyles;
